import { render, staticRenderFns } from "./ModalCertificacoes.vue?vue&type=template&id=4e1d7a74&scoped=true"
import script from "./ModalCertificacoes.vue?vue&type=script&lang=js"
export * from "./ModalCertificacoes.vue?vue&type=script&lang=js"
import style0 from "./ModalCertificacoes.vue?vue&type=style&index=0&id=4e1d7a74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1d7a74",
  null
  
)

export default component.exports